import{a as e}from"./chunk-YSXGDEY5.mjs";function m(a){return class{static{e(this,"SchemaHolder")}static schema=a}}e(m,"createToolParameters");export{m as a};
